import {Mapper} from '@s-ui/domain'

export class FromStockUrlMapperToSearchValueObjectMapper extends Mapper {
  constructor({config, fromSearchParamsToRequestVOMapper, searchRequestValueObjectFactory, parseQueryString}) {
    super()

    this._config = config
    this._fromSearchParamsToRequestVOMapper = fromSearchParamsToRequestVOMapper
    this._searchRequestValueObjectFactory = searchRequestValueObjectFactory
    this._parseQueryString = parseQueryString

    this._defaultSortBy = this._config.get('SORT_FIELDS').RELEVANCE
    this._defaultSortOrder = this._config.get('ORDER').DESC
    this._questionMark = this._config.get('page').QUESTION_MARK
    this._professionalStockPageName = this._config.get('page').PROFESSIONAL_STOCK_PAGE_NAME
  }

  _getSlugFromPathName({pathName}) {
    const {PROFESSIONAL_STOCK_WITH_ID_REGEX} = this._config.get('page')

    const result = PROFESSIONAL_STOCK_WITH_ID_REGEX.exec(pathName)

    if (!result) return

    const {
      groups: {contractId}
    } = result

    return contractId
  }

  _getUrlData({url}) {
    const {0: pathName, 1: queryParamsString} = url.split(this._questionMark)
    const query = this._parseQueryString(queryParamsString)

    return {query, contractId: this._getSlugFromPathName({pathName})}
  }

  map = ({urlVO}) => {
    const {url} = urlVO.toJSON()
    const {query, contractId} = this._getUrlData({url})
    const hasContractId = Boolean(contractId)

    const search = this._fromSearchParamsToRequestVOMapper
      .map({
        query,
        context: this._professionalStockPageName
      })
      .toJSON()

    if (hasContractId) search.contractId = contractId

    return this._searchRequestValueObjectFactory({...search})
  }
}
